"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../../enums");
const Venue_dto_1 = require("../Venue.dto");
const Visit_dto_1 = require("../Visit.dto");
class UserDto {
  constructor() {
    this.visits = [];
  }
}
exports.UserDto = UserDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "lastActiveAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: Visit_dto_1.VisitDto,
  isArray: true
}), __metadata("design:type", Array)], UserDto.prototype, "visits", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UserDto.prototype, "isInternal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user photo passed Ivy photo verification.'
}), __metadata("design:type", Boolean)], UserDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user shows their gender preferences on their profile.'
}), __metadata("design:type", Boolean)], UserDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserDto.prototype, "isBlockingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserDto.prototype, "isBlockedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserDto.prototype, "isLikingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserDto.prototype, "isLikedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], UserDto.prototype, "currentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDto.prototype, "currentVenueCheckedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDto.prototype, "secondsInVenue", void 0);
//# sourceMappingURL=User.dto.js.map